/* ADD FILE */
/* UNTAPPED - FABRICS PRICE PER METRE */
import { onAddElement } from './stripes-utils.js';
const { FABRIC_UNIT_FACTOR } = await import(window.STRIPES_CONSTANTS_URL);
window.__stripesLastAddWasFabric = false;

/* Common root that include the pirce and and the quantity */
const KALLES_PRODUCT_ROOT_SELECTORS = [
  '.hdt-main-product-quick-add', // quick view / modal
  '.hdt-product-info__list',     // main product page
  'hdt-sticky-btn-atc',           // sticky ATC bar
];
/**
 * When adding to the cart, intercept the form submit in order to add extra properties to the
 * line item, indicating that the line item is length-based.  After this the cart, checkkout and
 * order use this line item data to drive length-based functionality, rather than having to 
 * refer back to the original porduct. 
 */
onAddElement({
  root: document.body,
  selector: [
    '.is-sold-by-length form.hdt-main-product-form[action="/cart/add"]',
    '.is-sold-by-length form.hdt-sticky-atc__form[action="/cart/add"]',
  ].join(', '),
  onNode: upgradeLengthAddToCartForm
});

function upgradeLengthAddToCartForm(form) {
  if (form.hasAttribute('data-length-submit-ready')) return;
  form.setAttribute('data-length-submit-ready', '1');

  form.addEventListener(
    'submit',
    function (e) {
      // console.log("upgradeLengthAddToCartForm submit called");
      window.__stripesLastAddWasFabric = true;

      const displayInput = getDisplayQuantityForForm(form);
      if (!displayInput) return;  // it isn't a length-based product
      // console.log("product is length based");

      const productRoot = getKallesProductRoot(form);
      if (!productRoot) return;
      // console.log("product root found");

      // Try inside the product root first, then fall back to the main product section.
      // The sticky bar has no hdt-price of its own.
      let priceEl = productRoot.querySelector('hdt-price[data-wpd-variant-price]')
                ?? document.querySelector('.hdt-product-info__list hdt-price[data-wpd-variant-price]');

      if (!priceEl) return;
      // console.log("price found");

      const metres = Number(displayInput.value);
      if (!Number.isFinite(metres)) return;
      // console.log("price is number");

      const pricePerMetreCents = Number(priceEl.dataset.stripesPricePerMetreCents);
      if (!Number.isFinite(pricePerMetreCents)) return;

      // Add additional 
      setHiddenField(form, 'properties[_unit]', 'metre');
      setHiddenField(form, 'properties[_unit_factor]', String(FABRIC_UNIT_FACTOR));
      setHiddenField(form, 'properties[Quantity note]', "Fabric is priced and stocked in 0.5 m units, which is reflected in the order quantity.");
      setHiddenField(form, 'properties[Length ordered]', String(metres) + 'm');
      setHiddenField(form, 'properties[Price per m]', `£${(pricePerMetreCents/100).toFixed(2)}`);
    },
    true // capture: runs before Shopify submit
  );

  // Intercept the inline error message for fabric products
  const errorWrapper = form.closest('wrapp-hdt-pr-frm')?.querySelector('[ref="addToCartTextError"]');
  const errorMessageEl = errorWrapper?.querySelector('.hdt-error-message');

  if (errorWrapper && errorMessageEl) {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'hidden' && 
            !errorWrapper.hasAttribute('hidden')) {
          
          const text = errorMessageEl.textContent;
          const match = text.match(/Only (\d+) items? were added/);
          if (!match) return;

          const units = parseInt(match[1]);
          const metres = units / FABRIC_UNIT_FACTOR;

          errorMessageEl.textContent = 
            `Only ${metres} metres were added to your cart due to availability.`;
        }
      }
    }).observe(errorWrapper, { 
      attributes: true,
      attributeFilter: ['hidden']
    });

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.textContent?.includes('items were added')) {
            console.log('Found message in:', node);
            console.log('Parent:', node.parentElement);
            console.log('Classes:', node.className);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

}

function setHiddenField(form, name, value) {
  let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
  }
  input.value = value;
}

function getKallesProductRoot(el) {
  for (const selector of KALLES_PRODUCT_ROOT_SELECTORS) {
    const root = el.closest(selector);
    if (root) return root;
  }
  return null;
}

function getDisplayQuantityForForm(form) {
  // 1️⃣ Try inside the form (product page case)
  let input = form.querySelector('.display-quantity');
  if (input) return input;

  // 2️⃣ Fallback: inputs associated via form=""
  const formId = form.getAttribute('id');
  if (!formId) return null;

  return document.querySelector(
    `.display-quantity[form="${CSS.escape(formId)}"]`
  );
}


/**
 * A toast can be displayed with an error message that includes a quantity that needs to be 
 * converted.  We set a flag on the window on any form submit so we know if the last submit was for
 * a fabric or not.  For fabrics we already prtoess the form submit.  Now we need to it for 
 * non-fabrics to clear the flag.
 */

onAddElement({
  root: document.body,
  selector: 'form[action="/cart/add"]:not([data-length-submit-ready])',
  onNode: (form) => {
    form.addEventListener('submit', () => {
      window.__stripesLastAddWasFabric = false;
    }, true);
  }
});

onAddElement({
  root: document.body,
  selector: '.toast-container',
  onNode: (toastContainer) => {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (!node.classList.contains('toast')) continue;

          if (!window.__stripesLastAddWasFabric) continue;
   
          const text = node.textContent;
          const match = text.match(/Only (\d+) items? were added/);
          if (!match) continue;

          const units = parseInt(match[1]);
          const metres = units / FABRIC_UNIT_FACTOR;

          node.textContent = 
            `Only ${metres}m were added to your cart due to availability.`;
        }
      }
    }).observe(toastContainer, { childList: true });
  }
});


/**
 * Update the Inventory control which shows the amount of stock available 
 */
onAddElement({
  root: document.body,
  selector: '.is-sold-by-length hdt-variant-inventory',
  onNode: upgradeInventoryDisplay
});

function upgradeInventoryDisplay(inventoryEl) {
  function convertQuantities() {
    inventoryEl.querySelectorAll('[data-quantity]').forEach(el => {
      const text = el.textContent.trim();
      if (/^\d+$/.test(text)) {
        el.textContent = (parseInt(text) / FABRIC_UNIT_FACTOR) + 'm';
      }
    });
  }

  // Convert on load
  convertQuantities();

  // Convert on variant change (theme updates data-quantity spans)
  new MutationObserver(convertQuantities)
    .observe(inventoryEl, { 
      childList: true, 
      subtree: true, 
      characterData: true 
    });
}